import React, { SVGProps } from 'react'
const SvgSidenavNotificationsActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="evenodd"
      d="M10 1.652c-1.021 0-1.875.812-1.875 1.845v.102a5.627 5.627 0 0 0-3.75 5.305v.636c0 .441-.133.872-.382 1.237L2.04 13.635c-.661.968.032 2.28 1.204 2.28h3.694a3.066 3.066 0 0 0 3.001 2.44h.12a3.066 3.066 0 0 0 3.001-2.44h3.694c1.172 0 1.865-1.312 1.204-2.28l-1.952-2.858a2.193 2.193 0 0 1-.382-1.237v-.636a5.627 5.627 0 0 0-3.75-5.305v-.102c0-1.033-.854-1.845-1.875-1.845Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavNotificationsActive
